import { categories } from "@/mocks/leads";
import LeadCard from "@/components/feature/LeadCard";
import { Link } from "react-router-dom";
import { leads } from "@/mocks/leads";

export function CategorySection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20" id="categories">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="reveal">
            <span className="text-xs font-semibold tracking-[0.25em] text-primary-600">
              LEADS CATEGORY
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              按主题查找你关心的线索
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              从消费维权到行业调查，每个栏目都由核实编辑长期跟进，线索按主题归类，方便你持续追踪同一类议题的进展。
            </p>
          </div>
          <Link
            to="/leads"
            className="reveal flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            查看全部栏目
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/leads?c=${c.id}`}
              className="reveal group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className={`${c.icon} text-2xl`} aria-hidden="true" />
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  {String(c.count).padStart(3, "0")}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <span className="mt-5 flex items-center gap-1.5 text-xs font-medium text-primary-600">
                进入栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturedLeads() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20" id="featured">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="reveal">
            <span className="text-xs font-semibold tracking-[0.25em] text-primary-600">RECENT TIPS</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              近期完成核实的线索
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              每条内容都标注了核实状态：已核实代表已有多个独立来源印证，多方印证代表已获得间接材料，
              核实中代表我们仍在补充证据。
            </p>
          </div>
          <Link
            to="/leads"
            className="reveal flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            进入线索库
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {leads.slice(0, 6).map((lead) => (
            <div key={lead.id} className="reveal">
              <LeadCard lead={lead} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}